module.exports = __webpack_public_path__ + "img/type_40.prt.b31bb641.jpg";